import React from 'react'

const RegisterPatients = () => {
  return (
    <div>RegisterPatients</div>
  )
}

export default RegisterPatients